import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--toggle-visibility"
export default class extends Controller {
  static targets = ["trigger", "content"];
  static values = {
    visible: { type: Array, default: [] },
  };

  connect() {
    this._apply(this.triggerTarget.value);
  }

  toggle(e) {
    const target = e.currentTarget;

    this._apply(target.value);
  }

  _apply(value) {
    const id = Number(value);
    const content = this.contentTarget;

    if (this.visibleValue.includes(id)) {
      content.style.display = "block";
      content.disabled = false;
    } else {
      content.style.display = "none";
      content.disabled = true;
    }
  }
}
